import { createSvgIcon } from "@mui/material/utils";

/**
 * Single user icon.
 *
 * ![SingleUserIcon](data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItMi4wNCAtMi4wNCAyMS4wOCAyMC4wOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNDAiIGhlaWdodD0iMzgiIHN0eWxlPSJiYWNrZ3JvdW5kOiNmZmY7Ym9yZGVyLXJhZGl1czo0cHgiPjxwYXRoIGQ9Ik0xMy44MzM3IDE0QzEzLjgzMzcgMTMuMDY5NiAxMy44MzM3IDEyLjYwNDQgMTMuNzE4OCAxMi4yMjU5QzEzLjQ2MDMgMTEuMzczNiAxMi43OTM0IDEwLjcwNjcgMTEuOTQxMSAxMC40NDgyQzExLjU2MjYgMTAuMzMzMyAxMS4wOTc0IDEwLjMzMzMgMTAuMTY3IDEwLjMzMzNINi44MzM2NkM1LjkwMzI4IDEwLjMzMzMgNS40MzgwOSAxMC4zMzMzIDUuMDU5NTYgMTAuNDQ4MkM0LjIwNzMgMTAuNzA2NyAzLjU0MDM1IDExLjM3MzYgMy4yODE4MiAxMi4yMjU5QzMuMTY2OTkgMTIuNjA0NCAzLjE2Njk5IDEzLjA2OTYgMy4xNjY5OSAxNE0xMS41MDAzIDVDMTEuNTAwMyA2LjY1Njg1IDEwLjE1NzIgOCA4LjUwMDMzIDhDNi44NDM0NyA4IDUuNTAwMzMgNi42NTY4NSA1LjUwMDMzIDVDNS41MDAzMyAzLjM0MzE1IDYuODQzNDcgMiA4LjUwMDMzIDJDMTAuMTU3MiAyIDExLjUwMDMgMy4zNDMxNSAxMS41MDAzIDVaIiBzdHJva2U9IiMxMDE4MjgiIHN0cm9rZS13aWR0aD0iMS4zMzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48L3BhdGg+PC9zdmc+)
 */
const SingleUserIcon = createSvgIcon(
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8337 14C13.8337 13.0696 13.8337 12.6044 13.7188 12.2259C13.4603 11.3736 12.7934 10.7067 11.9411 10.4482C11.5626 10.3333 11.0974 10.3333 10.167 10.3333H6.83366C5.90328 10.3333 5.43809 10.3333 5.05956 10.4482C4.2073 10.7067 3.54035 11.3736 3.28182 12.2259C3.16699 12.6044 3.16699 13.0696 3.16699 14M11.5003 5C11.5003 6.65685 10.1572 8 8.50033 8C6.84347 8 5.50033 6.65685 5.50033 5C5.50033 3.34315 6.84347 2 8.50033 2C10.1572 2 11.5003 3.34315 11.5003 5Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  "SingleUser"
);

export default SingleUserIcon;
